import { formatMoney, LoanCriteria } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';
import { amountToValueMoneyMapper } from '@/utils/mappers/amountToValueMoneyMapper';

export const principalFieldColumn = ({ flex }: { flex?: number }) => {
  return {
    flex: flex ?? 0.26,
    field: 'principal',
    headerName: (
      <div style={{ textAlign: 'right' }}>
        <Text tId={'PRINCIPAL'} />
      </div>
    ),
    align: 'right',
    type: 'number',
    renderCell: (rowData: { row: LoanCriteria }) => (
      <div style={{ minWidth: '100px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
        {formatMoney(amountToValueMoneyMapper(rowData.row.loanConditions.principal))}
      </div>
    ),
  };
};
